export default __webpack_public_path__ + "static/media/The Seventh Bullet.e28a3154.png";